
export default {
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
        ticks: {
          stepSize: 1,
        }
      }]
    }
  },
  colors: [
    {
      borderColor: '#FFBFBE',
      backgroundColor: '#FFBFBE',
    },
    {
      borderColor: '#F98586',
      backgroundColor: '#F98586',
    },
    {
      borderColor: '#600005',
      backgroundColor: '#600005',
    },
    {
      borderColor: '#7FE9D9',
      backgroundColor: '#7FE9D9',
    },
    {
      borderColor: '#476FE3',
      backgroundColor: '#476FE3',
    },
    {
      borderColor: '#8DD477',
      backgroundColor: '#8DD477',
    },
  ],
  legend: true,
  plugins: [],
}
